var _rect, _rect2, _rect3, _path, _path2, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknowleg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    fill: "#9F9F9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.2858H12.5V16.0001H11V14.2858Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9529 10.4011C12.9529 10.1288 12.8555 9.91222 12.6605 9.75132C12.4656 9.59042 12.1913 9.50998 11.8375 9.50998C11.5342 9.50998 11.2346 9.5863 10.9386 9.73895C10.6426 9.8916 10.408 10.0958 10.2347 10.3516L9.48743 9.23768C9.74734 8.84162 10.0939 8.53633 10.5271 8.3218C10.9603 8.10726 11.444 8 11.9783 8C12.7652 8 13.3843 8.20215 13.8356 8.60647C14.2868 9.01078 14.5124 9.56773 14.5124 10.2773C14.5124 10.7559 14.4132 11.1623 14.2146 11.4965C14.0161 11.8306 13.711 12.1091 13.2995 12.3319C13.0829 12.4474 12.9132 12.5547 12.7905 12.6537C12.6678 12.7527 12.5793 12.862 12.5252 12.9817C12.471 13.1013 12.4439 13.2767 12.4439 13.5077V13.7305H10.9603V13.3716C10.9603 12.8352 11.0415 12.4268 11.2039 12.1462C11.3664 11.8657 11.6678 11.614 12.1082 11.3913C12.4259 11.2262 12.6461 11.0715 12.7688 10.9271C12.8916 10.7827 12.9529 10.6074 12.9529 10.4011Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    stroke: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknowleg);
export default __webpack_public_path__ + "static/media/unknowleg.463fc4421f231fb0f8b4624d1d4435c6.svg";
export { ForwardRef as ReactComponent };